import { LocationQuery } from 'vue-router';
import { ContractExtension } from './contract-extension.interface';

import { ContractExtensionService } from './contract-extension.service';
const service = new ContractExtensionService();

export interface ContractExtensionState {}

const state: ContractExtensionState = {};

const getters = {};

const mutations = {};

const actions = {
   async getContractExtensions(context: any, payload: { customerId: number; employeeId: number; query: LocationQuery }) {
      return await service.getContractExtensions(payload.customerId, payload.employeeId, payload.query);
   },
   async createContractExtension(context: any, payload: { customerId: number; employeeId: number; contractExtension: ContractExtension }) {
      return await service.postContractExtension(payload.customerId, payload.employeeId, payload.contractExtension);
   },
   async changeContractExtension(
      context: any,
      payload: { customerId: number; employeeId: number; contractExtensionId: number; contractExtension: ContractExtension },
   ) {
      return await service.putContractExtension(
         payload.customerId,
         payload.employeeId,
         payload.contractExtensionId,
         payload.contractExtension,
      );
   },
   async deleteContractExtension(context: any, payload: { customerId: number; employeeId: number; contractExtensionId: number }) {
      return await service.deleteContractExtension(payload.customerId, payload.employeeId, payload.contractExtensionId);
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
